require('../../modules/es6.math.asinh');
module.exports = require('../../modules/_core').Math.asinh;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/math/asinh.js
// module id = 1419
// module chunks = 2